export const sendMail = async (obj) => {
    return await fetch('https://contactme-iro5dkwkna-ew.a.run.app/portofolio-187b3/europe-west1/contactMe', {
        method: 'POST',
        body: JSON.stringify(obj)
    });
};